import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AudienceTypesEnum, CustomHttpHeaders, IReleaseNoteService, NotificationTypesEnum } from 'cl-common-angular';

@Injectable({ providedIn: 'root' })
export class ReleaseNoteService implements IReleaseNoteService {

    private readonly routePrefix: string = 'api/releasenote/';

    constructor(private httpClient: HttpClient) { }

    acknowledgeNotification = (notificationTypeId: NotificationTypesEnum, audienceTypeId: AudienceTypesEnum) => this.httpClient.post<void>(
        `${this.routePrefix}acknowledgenotification/${audienceTypeId}/${notificationTypeId}`, null,
        { headers: new HttpHeaders({ [CustomHttpHeaders.disableSpinner]: 'Y' }) });
}
